import { decrementRequests } from 'api/fetcher';
import axios from 'axios';
import { NotificationName } from 'utils/constants/notification';
import { fileDownload } from 'utils/fileDownload';

import getNewLeads from 'components/Dashboard/LeadsModal/getNewLeads';

import { setLeadsCount } from 'store/autoReducers';
import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type DownloadLeads = (props: {
    dates: {
        start: string;
        end: string;
    };
    callback?: (isLoading: boolean) => void;
}) => AppThunkAction;

const downloadLeadsUrl = (start: string, end: string) => `/api/v1/leads/report?dateFrom=${start}&dateTo=${end}`;

export const downloadLeads: DownloadLeads =
    ({ dates, callback }) =>
    async (dispatch) => {
        try {
            callback?.(true);
            const { start, end } = dates;

            await fileDownload(downloadLeadsUrl(start, end));

            const newLeads = await getNewLeads();
            dispatch(setLeadsCount(newLeads));
        } catch (e) {
            if (axios.isAxiosError(e)) {
                dispatch(addNotification(NotificationName.SomethingWentWrong));
            }
            throw e;
        } finally {
            decrementRequests();
            callback?.(false);
        }
    };
